// extracted by mini-css-extract-plugin
export var container = "styles-module--container--e886f";
export var desktop = "1340px";
export var form = "styles-module--form--08dd0";
export var giant = "2200px";
export var grid = "styles-module--grid--b9e72";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "768px";
export var textLockup = "styles-module--textLockup--75d61";